import { Component, type ReactNode } from 'react';
import classnames from 'classnames';
import classes from './ErrorLayout.module.scss';

export interface ELProps {
  title: string;
  message: ReactNode;
  image: ReactNode;
}

export class ErrorLayout extends Component<ELProps> {
  render() {
    const { title, message, image } = this.props;
    return (
      <div className={classes.container}>
        <div className={classes.image}>{image}</div>
        <h6 className={classnames('headline-6', classes.title)}>{title}</h6>
        <div className={classes.message}>{message}</div>
      </div>
    );
  }
}
